let isBound = false;

function closeProblemModal() {
  const modal = document.querySelector('[data-problem-modal]');
  if (!modal) return;
  modal.classList.remove('is-open');
  modal.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('stop-scrolling');
}

function openProblemModal() {
  const modal = document.querySelector('[data-problem-modal]');
  if (!modal) return;
  modal.classList.add('is-open');
  modal.setAttribute('aria-hidden', 'false');
  document.body.classList.add('stop-scrolling');
}

function bindGlobalListeners() {
  if (isBound) return;
  isBound = true;

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    const openModal = document.querySelector('[data-problem-modal].is-open');
    if (!openModal) return;
    closeProblemModal();
  });
}

function init() {
  const openButton = document.querySelector('[data-problem-modal-open]');
  const modal = document.querySelector('[data-problem-modal]');
  if (!openButton || !modal) return;

  openButton.addEventListener('click', function () {
    openProblemModal();
  });

  modal.querySelectorAll('[data-problem-modal-close]').forEach(function (element) {
    element.addEventListener('click', function () {
      closeProblemModal();
    });
  });

  bindGlobalListeners();
}

export { init, closeProblemModal };

